import { useState, useEffect, useRef } from "react";
import NavbarPng from "../assets/navfutcoinspot.png";
import NavbarPngMob from "../assets/FCS LOGO WHITE.png";
import NavbarLogoMob from "../assets/logomob.png";
import NavbarLogo from "../assets/navlogo.png";
import WalletLogo from "../assets/wallet.png";
import LoginButton from "../assets/account.png";
import XboxLogo from "../assets/Vector (1).png";
import PsLogo from "../assets/PS-LOGO.png";
import PcLogo from "../assets/PC-Logo.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Login from "./Login";
import api from "../utils/api"; // Ensure the API utility is correctly configured
import TopHeader from "./TopHeader";
import LogoutButton from "./LogoutButton";
import Register from "./Register";
import { usePricing } from "../context/PricingContext";
import { useAuth } from "../context/AuthContext";
import LogoutMobileButton from "./LogoutMobileButton";
import MobIcon1 from '../assets/mobicon1.png';
import MobIcon2 from '../assets/buyIcon.png';
import MobIcon3 from '../assets/sellIcon.png';
import MobIcon4 from '../assets/mobicon4.png';
import YellowMobIcon1 from '../assets/yellowicon4.png';
import YellowMobIcon2 from '../assets/yellowicon2.png';
import YellowMobIcon3 from '../assets/yellowicon3.png';
import YellowMobIcon4 from '../assets/yellowicon1.png';
import aff1 from '../assets/aff2.png';
import aff2 from '../assets/aff1.png';


const getCurrencySymbol = (currency) => {
  const symbols = {
    USD: "$",
    GBP: "£",
    EUR: "€",
    CAD: "C$",
    AUD: "A$",
    PKR: "₨",
    INR: "₹",
    SAR: "SAR", // Added symbol for SAR
  };
  return symbols[currency] || currency; // Fallback to currency code if symbol not found
};

const hardCodedRates = {
  USD: 1,
  GBP: 0.80,
  EUR: 0.96,
  CAD: 1.44,
  AUD: 1.61,
  SAR: 3.75, // Added SAR with exchange rate
};

const countryToCurrencyMap = {
  "United States": "USD",
  "United Kingdom": "GBP",
  "Germany": "EUR",
  "Canada": "CAD",
  "Australia": "AUD",
  "Saudi Arabia": "SAR", // Added mapping for Saudi Arabia
  // "Pakistan": "PKR",
  // "India": "INR",
};



const currencyOptions = [
  { code: "USD", name: "US Dollar" },
  { code: "GBP", name: "British Pound" },
  { code: "EUR", name: "Euro" },
  { code: "CAD", name: "Canadian Dollar" },
  { code: "AUD", name: "Australian Dollar" },
  { code: "SAR", name: "Saudi Riyal" }, // Added SAR
  // { code: "PKR", name: "Pakistani Rupee" },
  // { code: "INR", name: "Indian Rupee" },
];


const Navbar = () => {
  const [showPopup, setShowPopup] = useState(""); // "register" | "login" | null
  const toggleLoginPopup = () => setShowPopup((prev) => (prev === "login" ? null : "login"));
  const toggleRegisterPopup = () => setShowPopup((prev) => (prev === "register" ? null : "register"));

  const referralCode = localStorage.getItem("referralCode"); // Retrieve referral code from localStorage

  const handleNavigation = (platform) => {
    // Get the referralCode from the URL parameters only
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get("referralCode");

    // Construct the destination URL
    const basePath = `/buy-${platform}-coins`;
    const destinationUrl = referralCode ? `${basePath}?referralCode=${referralCode}` : basePath;

    // Navigate to the destination URL
    window.location.href = destinationUrl;
  };


  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsBuyDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const location = useLocation()
  const isTradeDisabled = ['/buy-xb-coins', '/buy-ps-coins', '/buy-pc-coins'].includes(location.pathname);

  const [activeLink, setActiveLink] = useState("home"); // Initialize with an empty string or a default value
  const [user, setUser] = useState(null);
  const [wallet, setWallet] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(true);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);
  const [isBuyOpen, setIsBuyOpen] = useState(false);
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const { currency, setCurrency, isAutoDetected, setIsAutoDetected } = usePricing();
  const buyDropdownRef = useRef(null);
  const currencyDropdownRef = useRef(null);
  const [convertedWallet, setConvertedWallet] = useState(0);
  const { token, isAdmin, logout } = useAuth(); // Use token and logout from AuthContext
  const navigate = useNavigate();
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Dropdown toggle state
  const [firstName, setFirstName] = useState("");
  const [isBuyDropdownOpen, setIsBuyDropdownOpen] = useState(false); // For Buy dropdown


  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen); // Toggle dropdown
  const toggleBuyDropdown = () => setIsBuyDropdownOpen((prev) => !prev);

  const [isCurrencyDropdownOpen, setIsCurrencyDropdownOpen] = useState(false);

  const handleCurrencyChange = (newCurrency) => {
    setIsAutoDetected(false); // Disable auto-detection
    setCurrency(newCurrency); // Update the currency
    setIsDropdownOpen(false); // Close dropdown
    window.location.reload(); // Reloads the page

  };


  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    setUser(null);
    setWallet(0);
    setIsAccountDropdownOpen(false);
    navigate("/");
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await api.get("/users/me");
        const { fullName, wallet } = response.data;
        setUser(fullName);
        setFirstName(fullName);
        setWallet(wallet);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await fetch("https://get.geojs.io/v1/ip/geo.json");
        const data = await response.json();
        const userCountry = data.country;
        const initialCurrency = countryToCurrencyMap[userCountry] || "USD";

        // Only update the currency if it was auto-detected
        if (isAutoDetected) {
          setCurrency(initialCurrency);
        }
      } catch (error) {
        console.error("Error fetching country:", error);

        // Fallback to default currency only if auto-detection is active
        if (isAutoDetected) {
          setCurrency("USD");
        }
      }
    };

    if (isAutoDetected) {
      fetchCountry();
    }
  }, [setCurrency, isAutoDetected]);


  useEffect(() => {
    if (wallet && hardCodedRates[currency]) {
      setConvertedWallet(wallet * hardCodedRates[currency]);
    }
  }, [wallet, currency]);

  const currencySymbol = getCurrencySymbol(currency);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        buyDropdownRef.current &&
        !buyDropdownRef.current.contains(event.target)
      ) {
        setIsBuyOpen(false);
      }
      if (
        currencyDropdownRef.current &&
        !currencyDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Update the active link when the route changes
    if (location.pathname === "/") {
      setActiveLink("home");
    } else if (location.pathname === "/sellCoins") {
      setActiveLink("sell");
    } else if (location.pathname === "/affiliateProgram" || location.pathname === "/UseraffiliateProgram") {
      setActiveLink("/affiliateProgram");
    } else if (location.pathname.includes("xb") || location.pathname.includes("ps") || location.pathname.includes("pc")) {
      setActiveLink("buy"); // Keep "buy" active when navigating inside the buy section
    }
  }, [location])
  return (
    <>
      <div className="">
        <TopHeader />
      </div>
      <nav className="bg-[#191919] text-white">
        <div className="lg:flex items-center justify-between px-4 py-4 sm:px-6 lg:p-8 hidden">
          {/* Logo Section NavbarLogo*/}
          <div className="flex items-center space-x-4 ">
            <Link to="/">
              <img src={NavbarLogo} alt="Controller Logo" className="w-10" />
            </Link>
            <Link to="/">
              <img src={NavbarPng} alt="Futcoinspot" className="h-6" />
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          {/* <button
            className="sm:hidden text-white text-2xl focus:outline-none"
            onClick={toggleMobileMenu}
          >
            <i className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
          </button> */}

          {/* Desktop Links */}
          <div className={`hidden sm:flex items-center space-x-20`}>
            <div className="relative" ref={buyDropdownRef}>
              <button
                className="flex items-center font-inter text-white font-medium hover:text-primary"
                onClick={() => setIsBuyOpen(!isBuyOpen)}
              >
                Trade
                <i className="ml-2 fas fa-chevron-down"></i>
              </button>
              {isBuyOpen && (
                <div className="absolute top-full left-0 flex flex-col bg-primary rounded-lg shadow-lg mt-2 z-20">
                  <div onClick={() => handleNavigation("xb")} className="px-4 py-2  hover:bg-yellow-200 text-black">
                    <div onClick={() => setIsBuyOpen(!isBuyOpen)} className="flex">
                      <img src={XboxLogo} alt="Xbox" className="mt-1 mr-1 w-4 h-4" />
                      Xbox
                    </div>
                  </div>
                  <div onClick={() => handleNavigation("ps")} className="px-4 py-2 hover:bg-yellow-200 text-black">
                    <div onClick={() => setIsBuyOpen(!isBuyOpen)} className="flex">
                      <img src={PsLogo} alt="PlayStation" className="mt-1 mr-1 w-4 h-4" />
                      <span className="mr-4"> PlayStation</span>
                    </div>
                  </div>
                  <div onClick={() => handleNavigation("pc")} className="px-4 py-2 hover:bg-yellow-200 text-black">
                    <div onClick={() => setIsBuyOpen(!isBuyOpen)} className="flex">
                      <img src={PcLogo} alt="PC" className="mt-1 mr-1 w-4 h-4" />
                      PC
                    </div>
                  </div>
                </div>
              )}
            </div>

            <Link to="/SellCoins" className="hover:text-primary ml-96">
              Sell
            </Link>

            <div className="relative mr-96" ref={currencyDropdownRef}>
              <button
                className="text-white px-4 py-2 rounded"
                onClick={() => setIsDropdownOpen((prev) => !prev)}
              >
                {currency} <i className="fas fa-chevron-down ml-2"></i>
              </button>
              {isDropdownOpen && (
                <div
                  className="absolute mt-2 bg-primary text-black rounded shadow-lg z-50"
                  style={{ minWidth: "120px" }} // Optional for setting a consistent dropdown width
                >
                  {currencyOptions.map((option) => (
                    <button
                      key={option.code}
                      className="block w-full px-4 py-2 hover:bg-yellow-200 text-left rounded"
                      onClick={() => handleCurrencyChange(option.code)}
                    >
                      {option.code}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <Link
              to={token ? "/UseraffiliateProgram" : "/affiliateProgram"} // Conditionally render the route
              className="hover:text-primary ml-96"
            >
              Affiliate
            </Link>


          </div>

          {/* Wallet & Account */}
          <div className="hidden sm:flex items-center space-x-6 relative">
            {user && (
              <div className="flex items-center space-x-2 text-primary">
                <img src={WalletLogo} alt="Wallet Icon" className="w-6 h-6" />
                <span className="font-medium">
                  {currencySymbol} {convertedWallet.toFixed(0)}
                </span>
              </div>
            )}
            <div className="relative">
              {user ? (
                <Link
                  to="/manageAccount"
                  className="flex items-center font-inter space-x-2 cursor-pointer text-primary"
                >
                  {user}
                  <img src={LoginButton} alt="Account Icon" className="w-6 h-6 ml-2" />
                </Link>
              ) : (
                <div
                  className="flex items-center space-x-2 cursor-pointer"
                  onClick={() => setShowPopup("register")} // Always open Register popup
                >
                  <img src={LoginButton} alt="Account Icon" className="w-6 h-6" />
                  <span className="font-medium hover:underline text-primary">Log In</span>
                </div>

              )}
            </div>

          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <>
            {/* Top Header */}
            <div className="lg:bg-[#191919] bg-[#191919] text-white z-50 flex justify-between items-center px-4 py-12 lg:hidden">
              <div className="relative">
                <button
                  className="bg-primary text-black font-inter font-bold p-1 flex items-center rounded"
                  onClick={() => setIsCurrencyDropdownOpen((prev) => !prev)} // Toggle only this dropdown
                >
                  <span className="ml-1">{currency}</span>
                  <i className="fas fa-chevron-down ml-1 text-xs"></i> {/* Smaller icon */}
                </button>

                {isCurrencyDropdownOpen && (
                  <div
                    className="absolute mt-2 bg-primary text-black rounded shadow-lg z-50 w-full"
                    style={{ minWidth: "120px" }}
                  >
                    {currencyOptions.map((option) => (
                      <button
                        key={option.code}
                        className="block w-full px-4 py-2 hover:bg-yellow-500 text-left rounded"
                        onClick={() => {
                          handleCurrencyChange(option.code); // Update currency
                          setIsCurrencyDropdownOpen(false); // Close only this dropdown
                        }}
                      >
                        {option.code}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <Link to="/">
                <img src={NavbarPngMob} alt="Futcoinspot" className="w-48 cursor-pointer" />
              </Link>

              <div className="flex items-center">
                {/* wallet here */}
                <img src={WalletLogo} alt="Wallet Icon" className="w-5 h-5 mr-1" />
                <span className="font-bold text-sm font-inter text-primary">
                  {currencySymbol} {convertedWallet.toFixed(0)}
                </span>
              </div>
            </div>

            {/* Bottom Navigation */}
            <div className="fixed bottom-0 font-inter font-bold left-0 right-0 bg-primary text-black z-50 flex justify-evenly items-center md:hidden px-3 py-2">
              {/* Home */}
              <Link
                to="/"
                className={`flex flex-col items-center text-center rounded-3xl border border-black w-20 ${activeLink === "home"
                  ? "text-white bg-[#191919] rounded-full py-1 px-2" // Active styles
                  : "bg-primary border-black rounded-full py-1 px-2" // Inactive styles
                  }`}
                onClick={() => setActiveLink("home")}
              >
                {activeLink === "home" ? (
                  <img
                    src={YellowMobIcon4}
                    alt="Futcoinspot Active Home"
                    className="w-3 h-3 mb-1 mt-1" // Adjust size if needed
                  />
                ) : (
                  <img
                    src={MobIcon4}
                    alt="Futcoinspot Inactive Home"
                    className="w-3 h-3 mt-1 mb-1" // Adjust size if needed
                  />
                )}
              </Link>

              {/* Buy */}
              <div ref={dropdownRef} className="relative rounded-3xl border border-black w-20">
                <button
                  onClick={() => {
                    if (!isTradeDisabled) {
                      toggleBuyDropdown();
                      setActiveLink("buy");
                    }
                  }}
                  className={`flex flex-row items-center justify-center text-center w-full ${activeLink === "buy"
                    ? "text-white bg-[#191919] rounded-full py-1 px-2"
                    : "bg-primary border-black rounded-full py-1 px-2"
                    }`}
                >
                  {activeLink === "buy" ? (
                    <img src={YellowMobIcon2} alt="Futcoinspot Active Buy" className="mr-1 w-5 h-5" />
                  ) : (
                    <img src={MobIcon2} alt="Futcoinspot Inactive Buy" className="mr-1 w-5 h-5" />
                  )}
                  <span className="font-inter text-[10px] truncate">Trade</span>
                </button>

                {isBuyDropdownOpen && (
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-52 bg-primary rounded-lg shadow-lg z-20 flex flex-col">
                    <div
                      className="px-4 py-2 hover:bg-yellow-200 text-black flex items-center font-inter text-[12px] cursor-pointer"
                      onClick={() => handleNavigation("xb")}
                    >
                      <img src={XboxLogo} alt="Xbox" className="mr-2 w-5 h-5" />
                      Xbox
                    </div>
                    <div
                      className="px-4 py-2 hover:bg-yellow-200 text-black flex items-center font-inter text-[12px] cursor-pointer"
                      onClick={() => handleNavigation("ps")}
                    >
                      <img src={PsLogo} alt="PlayStation" className="mr-2 w-5 h-5" />
                      PlayStation
                    </div>
                    <div
                      className="px-4 py-2 hover:bg-yellow-200 text-black flex items-center font-inter text-[12px] cursor-pointer"
                      onClick={() => handleNavigation("pc")}
                    >
                      <img src={PcLogo} alt="PC" className="mr-2 w-5 h-5" />
                      PC
                    </div>
                  </div>
                )}
              </div>

              {/* Sell */}
              <Link
                to="/sellCoins"
                className={`flex flex-row items-center justify-center text-center rounded-3xl border border-black w-20 ${activeLink === "sell" ? "text-white bg-[#191919] rounded-full py-1 px-2" : "bg-primary border-black rounded-full py-1 px-2"
                  }`}
                onClick={() => setActiveLink("sell")}
              >
                {activeLink === "sell" ? (
                  <img src={YellowMobIcon3} alt="Futcoinspot Active Sell" className="mr-1 w-5 h-5" />
                ) : (
                  <img src={MobIcon3} alt="Futcoinspot Inactive Sell" className="mr-1 w-5 h-5" />
                )}
                <span className="font-inter text-[10px] truncate">Sell</span>
              </Link>

              {/* User Profile */}
              {user ? (
                <Link
                  to="/manageAccMob"
                  className={`flex flex-row items-center justify-center text-center border border-black w-20 rounded-3xl ${activeLink === "account"
                    ? "text-white bg-[#191919] rounded-full py-1 px-2"
                    : "bg-primary border-black rounded-full py-1 px-2"
                    }`}
                  onClick={() => setActiveLink("account")}
                >
                  <img
                    src={activeLink === "account" ? YellowMobIcon1 : MobIcon1}
                    alt="Account Icon"
                    className="w-3 h-3 mr-0.5 mt-1 mb-1" // Consistent icon size
                  />
                  <span className="font-inter text-[10px] truncate">Profile</span>
                </Link>
              ) : (
                <button
                  onClick={() => setShowPopup("register")} // Always open Register popup first
                  className={`flex flex-row items-center justify-center border border-black w-20 rounded-3xl ${activeLink === "login"
                    ? "text-white bg-[#191919] rounded-full py-1 px-2"
                    : "bg-primary border-black rounded-full py-1 px-2"
                    }`}
                >
                  <i className="fas fa-sign-in-alt text-xl"></i>
                  <span className="font-inter text-[10px] ml-1 truncate">Login</span>
                </button>
              )}
            </div>
          </>
        )}


      </nav>

      {/* Popups */}
      {showPopup === "register" && (
        <Register
          onClose={() => setShowPopup(null)} // Close the popup
          showLogin={() => setShowPopup("login")} // Switch to Login popup
        />
      )}

      {showPopup === "login" && (
        <Login
          onClose={() => setShowPopup(null)} // Close the popup
          showRegister={() => setShowPopup("register")} // Switch to Register popup
        />
      )}

    </>
  );
};

export default Navbar;